module.exports = __webpack_public_path__ + "img/22_Kirbisser.jpg";